var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#FDEDF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 14.6H29V16.4H27.2V28.1C27.2 28.3387 27.1052 28.5676 26.9364 28.7364C26.7676 28.9052 26.5387 29 26.3 29H13.7C13.4613 29 13.2324 28.9052 13.0636 28.7364C12.8948 28.5676 12.8 28.3387 12.8 28.1V16.4H11V14.6H15.5V11.9C15.5 11.6613 15.5948 11.4324 15.7636 11.2636C15.9324 11.0948 16.1613 11 16.4 11H23.6C23.8387 11 24.0676 11.0948 24.2364 11.2636C24.4052 11.4324 24.5 11.6613 24.5 11.9V14.6ZM25.4 16.4H14.6V27.2H25.4V16.4ZM17.3 19.1H19.1V24.5H17.3V19.1ZM20.9 19.1H22.7V24.5H20.9V19.1ZM17.3 12.8V14.6H22.7V12.8H17.3Z",
    fill: "#DF1C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.9f73901a2ec2b81f65c6f0830c40daf3.svg";
export { ForwardRef as ReactComponent };